const config = {
  MOBILE_APP_VERSION: "1.0",
  MOBILE_APP_VERSION_URL: "https://www.okit.de/",
};

export default config;
